import { render } from "./Map.vue?vue&type=template&id=c5685dc4"
import script from "./Map.vue?vue&type=script&lang=js"
export * from "./Map.vue?vue&type=script&lang=js"

import "./Map.vue?vue&type=style&index=0&id=c5685dc4&lang=scss"
script.render = render

export default script